function pushFavoriteEvent(button, eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            currency: 'JPY',
            value: Number(button.dataset.productPrice) || 0,
            items: [{
                item_id: button.dataset.productId,
                item_name: button.dataset.productName,
                item_brand: button.dataset.productType,
                item_category: button.dataset.productType,
                price: Number(button.dataset.productPrice) || 0,
                quantity: 1
            }]
        }
    });
}

if (!customElements.get('product-favorite-button')) {
    class ProductFavoriteButton extends HTMLElement {
        constructor() {
            super();
            this.busy = false;
            this.addEventListener('click', this.handleActivate.bind(this));
            this.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.handleActivate();
                }
            });
        }

        handleActivate() {
            if (this.busy) return;

            const loggedIn = this.dataset.loggedIn === 'true';
            if (!loggedIn) {
                pushFavoriteEvent(this, 'favorite_click_guest');
                window.location.href = this.dataset.loginUrl;
                return;
            }

            this.toggleFavorite();
        }

        async toggleFavorite() {
            this.busy = true;
            const wasFavorited = this.dataset.favorited === 'true';
            // optimistic UI update
            this.setFavorited(!wasFavorited);

            try {
                const res = await fetch('/apps/favorites', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ productId: this.dataset.productId }),
                });

                if (!res.ok) {
                    throw new Error(`status ${res.status}`);
                }

                const data = await res.json();
                this.setFavorited(Boolean(data.favorited));
                pushFavoriteEvent(this, data.favorited ? 'add_to_wishlist' : 'remove_from_wishlist');
            } catch (err) {
                console.error('お気に入りの更新に失敗しました', err);
                // roll back optimistic update
                this.setFavorited(wasFavorited);
            } finally {
                this.busy = false;
            }
        }

        setFavorited(favorited) {
            this.dataset.favorited = favorited ? 'true' : 'false';
            const label = favorited ? this.dataset.labelRemove : this.dataset.labelAdd;
            this.setAttribute('aria-label', label);
            const labelEl = this.querySelector('.product-favorite-toggle__label');
            if (labelEl) labelEl.textContent = label;
        }
    }

    customElements.define('product-favorite-button', ProductFavoriteButton);
}
